<div
  #sectionsContainer
  tabindex="-1"
  class="vip-dropdown-secoes"
  [class.categorias-layout]="hasCategories"
>
  <ng-container *ngIf="hasCategories; else secaoTemplate">
    <div
      class="secao-container"
      [ngClass]="{
        'count-2': itemsQuantity === 2,
        'count-3': itemsQuantity >= 3,
      }"
    >
      <div
        *ngFor="let secao of items; trackBy: trackByFn"
        class="secao-wrapper"
      >
        <vip-custom-link
          [url]="buildUrl(secao)"
          [useHref]="false"
          class="submenu-item block"
          (click)="emitClick(secao)"
          [attr.data-cy]="'secao-item-' + secao.classificacao_mercadologica_id"
        >
          {{ stringUtilsService.capitalizeWords(secao.descricao) }}
        </vip-custom-link>

        <ul>
          <li
            *ngFor="let categoria of secao.children; trackBy: trackByFn"
            class="submenu-item mt-2"
            #itemsDropdown
            [attr.data-cy]="
              'categoria-item-' + categoria.classificacao_mercadologica_id
            "
          >
            <vip-custom-link
              [url]="buildUrl(categoria)"
              [useHref]="false"
              class="block flex-1"
              (click)="emitClick(categoria)"
            >
              {{ categoria.descricao }}
            </vip-custom-link>
          </li>
        </ul>
      </div>
    </div>
  </ng-container>

  <ng-template #secaoTemplate>
    <ul [class.max-height]="hasShowMoreButton" data-cy="secoes-container">
      <li
        *ngFor="let secao of items | slice: 0 : showQtd; let last = last"
        class="submenu-item flex"
        [class.mb-3]="!last"
      >
        <vip-custom-link
          [url]="buildUrl(secao)"
          [useHref]="false"
          class="block flex-1"
          (click)="emitClick(secao)"
          [attr.data-cy]="'secao-item-' + secao.classificacao_mercadologica_id"
        >
          {{ stringUtilsService.capitalizeWords(secao.descricao) }}
        </vip-custom-link>
      </li>
    </ul>

    <p
      class="show-more-button"
      [ngClass]="hasShowMoreButton ? 'block' : 'hidden'"
      role="button"
      aria-label="Ver mais seções"
      (click)="showMoreAndRefocus()"
      (keydown.enter)="showMoreAndRefocus(); $event.preventDefault()"
      (keydown.space)="showMoreAndRefocus(); $event.preventDefault()"
      tabindex="0"
    >
      ver mais
    </p>
  </ng-template>
</div>
